import React, { useState } from "react";
import SearchIcon from "../../Assets/OrderManagement/SearchIcon.svg";
import TabButton from "../../Components/TabButton/TabButton";
import OrdersList from "./Components/OrdersList";
import { useDispatch, useSelector } from "react-redux";
import { changeTab, setModal, toggleModal } from "../../Features/orderManagementSlice";
import Loading from "../../Components/Loading/Loading";
import Error from "../../Components/Error/Error";
import ReturnOrderList from "./ReturnOrder/ReturnOrderList";
import ExportModal from "./Modals/ExportModal";
import Modal from "./Modals/Modal";

const tabs = [
  {
    id: "all",
    name: "All orders",
  },
  {
    id: "pending",
    name: "Pending",
  },
  {
    id: "ready-to-pickup",
    name: "Ready to Pickup",
  },
  {
    id: "transit",
    name: "In Transit",
  },
  {
    id: "out-for-delivery",
    name: "Out for Delivery",
  },
  {
    id: "delivered",
    name: "Delivered",
  },
  {
    id: "cancelled",
    name: "Cancelled",
  },
  {
    id: "returned",
    name: "Return",
  },
];

function OrderManagement() {
  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState("");

  const activeTab = useSelector((state) => state.orderManagement.activeTab);
  const modalDisplay = useSelector(
    (state) => state.orderManagement.modalDisplay
  );
  const { loading } = useSelector(
    (state) => state.orderManagement.orders
  );

  const updateActiveSection = (selection) => {
    dispatch(changeTab(selection));
  };

  const handleExportButton = () => {
    dispatch(setModal('export'));
  };

  const changeHandler = (e) => {
    setSearchInput(e.target.value);
  };

  if (loading === "loading") {
    return <Loading />;
  }

  if (loading === "failed") {
    return <Error />;
  }

  return (
    <div className="w-full overflow-y-scroll pb-32">
      <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
        <div className="w-fit">
          <h1 className="text-[#121212] font-bold leading-8 text-[24px]">
            Order Management
          </h1>
        </div>

        <div className="flex gap-4">
          <div className="w-64 flex items-center gap-2 bg-[#F5F5F5] border border-[#EAEAEA] rounded-lg px-4 py-[10px] focus-within:border-primaryColor">
            <div className="w-5 h-5 flex items-center justify-center">
              <img src={SearchIcon} alt="" />
            </div>

            <input
              className="outline-none w-[calc(100%-20px)] bg-transparent font-medium text-[14px] leading-[22px] text-[#666666]"
              placeholder="Search order"
              type="text"
              value={searchInput}
              onChange={changeHandler}
              name="order-search"
            />
          </div>

          <button
            onClick={handleExportButton}
            className="bg-primaryColor hover:bg-primaryAccent rounded-md px-3 py-[10px] text-buttonText font-semibold text-[14px] leading-[22px]"
          >
            Export
          </button>
        </div>
      </div>

      <div className="flex border-b-2 border-[#F5F5F5] m-[0px_19px_0px_20px]">
        {tabs.map((tab) => {
          return (
            <TabButton
              key={tab.id}
              id={tab.id}
              optionName={tab.name}
              selected={activeTab}
              handleSelect={updateActiveSection}
            />
          );
        })}
      </div>

      {activeTab === "returned" ? (
        <ReturnOrderList />
      ) : (
        <OrdersList />
      )}

      <Modal />
    </div>
  );
}

export default OrderManagement;
